import { defineComponent as _defineComponent } from 'vue'
import { computed, watch, onMounted } from 'vue'
    import { useId } from '@common/composables'
    import { useOverallReportPage } from '@RankHR/Regions/pages-core'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'OverallReportPage',
  setup(__props) {

    document.title = "Summary Report"

    const id = useId()

    const { useOverallReportQuery } = useOverallReportPage()
    const { modelOverallReportQueryV1, runOverallReportQueryV1 } = useOverallReportQuery(id)

    const model = computed(() => modelOverallReportQueryV1.value)
    const regionName = computed(() => modelOverallReportQueryV1.value?.RegionName)
    const votingCycle = computed(() => modelOverallReportQueryV1.value?.VotingCycle)
    const totalPossibleScore = computed(() => modelOverallReportQueryV1.value?.TotalPossibleScore)
    const boardHighScore = computed(() => modelOverallReportQueryV1.value?.BoardHighScore)
    const boardAverage = computed(() => modelOverallReportQueryV1.value?.BoardAverage)
    const boardRanking = computed(() => modelOverallReportQueryV1.value?.BoardRanking)
    const overallBoardScoringStatistics = computed(() => modelOverallReportQueryV1.value?.OverallBoardScoringStatistics)
    const ratingRatios = computed(() => modelOverallReportQueryV1.value?.RatingRatios)
    const error = computed(() => modelOverallReportQueryV1.value?.Error)

    onMounted(() => {
        runOverallReportQueryV1()
    })

return { __sfc: true,id, useOverallReportQuery, modelOverallReportQueryV1, runOverallReportQueryV1, model, regionName, votingCycle, totalPossibleScore, boardHighScore, boardAverage, boardRanking, overallBoardScoringStatistics, ratingRatios, error }
}

})